import { render, staticRenderFns } from "./CourseBuilderImage.vue?vue&type=template&id=8dfb9798&scoped=true&"
import script from "./CourseBuilderImage.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfb9798",
  null
  
)

export default component.exports